import ServicePath from "@/core/ServicePath"
import { MainRequest } from "@/core/request";

export default class ColposcopyForm extends MainRequest{

   static getColposcopyForm(data) {
      return this.postSEC(ServicePath.COLPOSCOPY_FORM, data);
   }
   
   static saveColposcopyForm(data) {
      return this.postSEC(ServicePath.SAVE_COLPOSCOPY_FORM, data);
   }

   static editColposcopyForm(data) {
      return this.postSEC(ServicePath.EDIT_COLPOSCOPY_FORM, data);
   }

   static getColposcopyFormFromInterpretation(data) {
      return this.postSEC(ServicePath.GET_COLPOSCOPY_FORM_FROM_INTERPRETATION, data);
   }

   static editColposcopyFormFromInterpretation(data) {
      return this.postSEC(ServicePath.EDIT_COLPOSCOPY_FORM_FROM_INTERPRETATION, data);
   }

   static getFilesColposcopyFormFromInterpretation(data) {
      return this.postSEC(ServicePath.INTERPRETATION_GET_FILES, data);
   }

}